import type { HttpClient } from '@wix/cli-http-client';
import type { Options } from 'p-retry';
import pRetry from 'p-retry';
import {
  createTunnel,
  deleteTunnel,
} from '@wix/ambassador-apps-hosting-v1-deployment/http';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { getTestOverrides } from '@wix/cli-test-overrides';
import { createTunnelSchema } from './schemas.js';

export class TunnelClient {
  private readonly retryOptions: Options;

  constructor(private readonly httpClient: HttpClient) {
    const { minRetryTimeout } = getTestOverrides();

    this.retryOptions = {
      retries: 3,
      minTimeout: minRetryTimeout,
      maxTimeout: 3 * 1000,
    };
  }

  public createTunnel = async ({ port }: { port: number }) => {
    try {
      const { data } = await pRetry(
        () => this.httpClient.request(createTunnel({ port })),
        this.retryOptions
      );

      return createTunnelSchema.parse(data);
    } catch (error) {
      throw new CliError({
        code: CliErrorCode.FailedToCreateTunnel(),
        cause: error,
      });
    }
  };

  public deleteTunnel = async (tunnelId: string) => {
    try {
      await pRetry(
        () => this.httpClient.request(deleteTunnel({ id: tunnelId })),
        this.retryOptions
      );
    } catch (error) {
      throw new CliError({
        code: CliErrorCode.FailedToDeleteTunnel(),
        cause: error,
      });
    }
  };
}
